module.exports = __webpack_public_path__ + "static/media/ico-tracing-active.b15274b3.svg";